module.exports = __webpack_public_path__ + "static/media/NeuzeitGro.115d1d1d.ttf";